export function linkAnchor() {
    $(".page-title .button[href^=\"#\"]").on("click", function (e) { 
        e.preventDefault();
        const $dataTarget = $(this).attr("href");
        const $targetTop = $($dataTarget).offset().top;
        $("html, body").animate({
            scrollTop: $targetTop
        }, 600);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/linkAnchor.js